export function makeChatAgentConversationFeedbackResourceId(
  conversationUuid: string,
  messageIndex: number,
): string {
  return `${conversationUuid}:${messageIndex}`;
}
